<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">Risk Factor Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <form-require-noti />
      <label>Name <require-sign /></label>
      <v-text-field
        v-model.trim="riskFactor.name"
        :error-messages="handleFieldErrors($v.riskFactor.name)"
        type="text"
        outlined
        dense
      ></v-text-field>
      <label>Myanmar Name </label>
      <v-text-field
        v-model.trim="riskFactor.mm_name"
        type="text"
        outlined
        dense
      ></v-text-field>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn
        v-if="riskFactor.id"
        @click.prevent="emitRiskFactorData"
        class="form-btn"
      >
        Update
      </v-btn>
      <v-btn v-else @click.prevent="emitRiskFactorData" class="form-btn">
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";
import FormRequireNoti from "@/components/notification/FormRequireNoti.vue";
import RequireSign from "@/components/notification/RequireSign.vue";

export default {
  components: { FormRequireNoti, RequireSign },

  mixins: [ValidationMixin],
  props: {
    riskFactor: {
      type: Object,
      default: () => {
        return {
          name: null,
          mm_name: null,
        };
      },
    },
  },
  data: () => ({}),
  validations: {
    riskFactor: {
      name: {
        required,
      },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    emitRiskFactorData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          name: this.riskFactor.name,
          mm_name: this.riskFactor.mm_name,
        };

        this.riskFactor.id ? (data.id = this.riskFactor.id) : false;

        this.$emit("emitRiskFactorData", data);

        this.riskFactor.name = null;
        this.riskFactor.mm_name = null;
        this.$v.$reset();
      }
    },
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
